import { useState, useCallback } from 'react';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';

interface PollAnswerQuestion {
  questionKey: string;
  answerKey: string;
}

interface PollAnswerRequest {
  questions: PollAnswerQuestion[];
}

interface UsePollAnswerResult {
  submitAnswer: (pollId: string, questionKey: string, answerKey: string) => Promise<void>;
  isLoading: boolean;
  error: Error | null;
  isSuccess: boolean;
}

export const usePollAnswer = (): UsePollAnswerResult => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const submitAnswer = useCallback(async (pollId: string, questionKey: string, answerKey: string) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    const request: PollAnswerRequest = {
      questions: [
        {
          questionKey,
          answerKey,
        },
      ],
    };

    try {
      await apiClient.post(ApiType.apimNafNoApi, {
        url: ApiPaths[ApiType.apimNafNoApi].polls.answers(pollId),
        data: request,
      });
      setIsSuccess(true);
    } catch (e: unknown) {
      setError(e as Error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    submitAnswer,
    isLoading,
    error,
    isSuccess,
  };
};
